import { render, staticRenderFns } from "./PublisherSetupTabPricelist.vue?vue&type=template&id=73a469ab"
import script from "./PublisherSetupTabPricelist.vue?vue&type=script&lang=js"
export * from "./PublisherSetupTabPricelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports